/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Zero: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M21.707 3.70703L17.8301 7.58301C17.9401 8.03745 18 8.51172 18 9V15C18 18.3137 15.3137 21 12 21C9.93765 21 8.11803 19.9597 7.03809 18.375L3.70703 21.707L2.29297 20.293L6.16992 16.415C6.06016 15.9612 6 15.4876 6 15V9C6.00004 5.68635 8.68635 3.00004 12 3C14.0618 3 15.8809 4.04001 16.9609 5.62402L20.293 2.29297L21.707 3.70703ZM8.49121 16.9219C9.17101 18.1604 10.4874 19 12 19C14.2091 19 16 17.2091 16 15V9.41406L8.49121 16.9219ZM12 5C9.79092 5.00004 8.00004 6.79092 8 9V14.5859L15.5078 7.07715C14.8278 5.83931 13.5121 5 12 5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
